import React from "react";
import "../index.css";
import "../theme-login-style.css";
import { invalidateCache } from "../store/cacheStore";


import { EyeInvisibleOutlined, EyeTwoTone, CheckCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Form,
  Input,
  Image,
  message,
  Modal,
  Spin,
  QRCode,
  Select,
} from "antd";
import withRouter from "../withRouter";
import { postApi } from "./Utility";
import { encode as base64_encode } from "base-64";
import Cookies from "universal-cookie";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";

import LiveTrackingStore from "../store/LiveTrackingStore";
import EmailReportStore from "../store/EmailReportStore";
import ForgetPassStore from "../store/ForgetPassStore";
import UsersStore from "../store/UsersStore.js";
import config from "../config.js";
import { Helmet } from "react-helmet";
import drive7Icon from "../../src/assets/images/drive7.ico";
import awtlIcon from "../../src/assets/images/awtl.ico";
import starlingIcon from "../../src/assets/images/starling.ico";
import AddLoginFields from "./Plugins/AddLogin/AddLoginFields.js";
import ctraxIcon from "../../src/assets/images/ctrax.ico";
import conf from "../config.js";
import proawtlIcon from "../../src/assets/images/awtl_fav.ico";
import intellicab from "../../src/assets/images/intellicab.ico";
import baseConfig from "../baseconfig.json";
import AWTLHelpSection from "./Plugins/AddLogin/AWTLHelpSection.js";

class Login extends React.Component {
  constructor(props) {
    super(props);
    // this.verifyOtpFormRef = React.createRef();
    this.state = {
      selectedLang: config.language,
      loading: false,
      forgetpassmodal: false,
      engActiveBtn: true,
      araActiveBtn: false,
      forgetPassLoading: false,
      showGoogleQRCode: false,
      showQRCode: false,
      openModalForQRCode: false,
      showUpdateInfoModal: false,
      pendingNavigatePath: null,
      showVerifyOtpModal: false,
      showAlertModal: false,
      showVerifyOtpAdminModal: false,
      showVerifyOtpAdminModalconfirmation: false,
      loginRes: {},
      otpFormData: {},
      otpTimer: 600,        // 600 seconds = 10 minutes
      otpTimerActive: false,
      otpTimerInterval: null,
      emailOtpVerified: false,
      phoneOtpVerified: false,
      otpValidationMessage: null
    };
    this.optionsWithDisabled = [
      {
        label: "English",
        value: "english",
        direction: "ltr",
      },
      {
        label: "عربي",
        value: "arabic",
        direction: "rtl",
      },
    ];

    // this.props.navigate('/home')
    //this.navigate = useNavigate();
    this.liveTrackingStore = new LiveTrackingStore(this);
    this.forgetPassStore = new ForgetPassStore(this);
    this.forgetFormRef = React.createRef(this);

    this.submitHandler = this.submitHandler.bind(this);
    this.onLangChange = this.onLangChange.bind(this);
    this.emailReportStore = new EmailReportStore(this);
    this.cookies = new Cookies();
    this.userstoresubmit = new UsersStore(this);
  }
  async submitHandler(values) {
    try {
      this.setState({ loading: true });
      var body = {
        userEmail: values.userEmail,
        password: values.password,
      };
      var postData = { tokenId: -1, user: body };

      const base64Input = await base64_encode(JSON.stringify(postData));

      // var response = await postApi
      //   .getClient()
      //   .post("index.php?c=user&a=login", "postData=" + base64Input);

      var response = "";
      if (conf.currentFlavor === "nodeui") {
        response = await postApi
          .getClient("NodeCoreUrl")
          .post("/auth/login", postData);
      }
      if (
        conf.currentFlavor === "starlingtechs" ||
        conf.currentFlavor === "default"
      ) {
        response = await postApi
          .getClient()
          .post("index.php?c=user&a=login", "postData=" + base64Input);
      } else {
        response = await postApi
          .getClient("")
          .post(config.NodeUrl + "/auth/login", postData);
        // response = await postApi
        //   .getClient()
        //   .post("index.php?c=user&a=login", "postData=" + base64Input);
      }

      var postData2 = { roleId: response?.data?.data?.roleId };
      const base64Input2 = await base64_encode(JSON.stringify(postData2));

      // var response2 = await postApi
      // .getClient()
      // .post("index.php?c=user&a=usermodules3", "postData=" + base64Input2);

      console.log(response);
      // this.context.setRuleSelector(response.data.universal.ruleselectors)
      // console.log(response.data.universal.ruleselectors,"qwewreqrtrttry")
      // this.ruleSelector=response.data.universal.ruleselectors;

      this.context.rolePermission = response.data?.data?.rolePermission;
      this.emailReportStore.reportNames =
        response?.data?.data?.universal?.reports;

      this.setState({ loginRes: response.data.data })
      if (response?.data?.data && response.data["success"] == "S") {

        invalidateCache('companyList');
        invalidateCache('vehicleList');
        invalidateCache('vehicleList');

        // console.log(this.props.setCookie) //this.props.setCookie("userToken",response.data.token,{path:"/"});
        // console.log(response.data.data)
        // this.context.menuShow = true

        console.log("token login", response.data.data);
        this.cookies.set("mapShow", 1);
        this.context.menuShow = true;
        const coockieData = {
          userToken: response.data.data.token,
          userName: response.data.data.name,
          userCompanyId: response.data.data.companyId,
          logo: response.data.data.logo,
          userId: response.data.data.userId,
          isadmin: response.data.data.isadmin,
          issuperadmin: response.data.data.issuperadmin,
          //  rolePermission: response.data?.data?.rolePermission,
          //   rolePermission2: response.data?.data?.rolePermission2,
          photo: response.data?.data?.photo,
          mapSetting: response?.data?.data?.mapSetting,
          mapSetting2: response?.data?.data?.mapSetting2,
          roleId: response?.data?.data?.roleId,
          roleId2: response?.data?.data?.roleId2,
          showLaunchingDashboard: 0,
          isLogin: response.data.data?.isLogin,
          companyId: response.data.data?.companyId,
          selectedLang: this.state.selectedLang,
          emailId: response.data.data?.emailId,
          mobileno: response.data.data?.mobileno,
          name: response.data.data?.name,

        };
        console.log(coockieData, "coockieData");

        this.context.mapSetting = response?.data?.data?.mapSetting;
        this.context.mapSetting2 = response?.data?.data?.mapSetting2;

        const helpEmail = response?.data?.data?.globalData?.helpEmail ?? "";
        const helpPhone = response?.data?.data?.globalData?.helpPhone ?? "";
        const mapKey = response?.data?.data?.globalData?.mapKey ?? "";


        localStorage.setItem(
          "helpEmail",
          helpEmail
        );

        localStorage.setItem(
          "helpPhone",
          helpPhone
        );

        localStorage.setItem(
          "mapKey",
          mapKey
        );

        this.cookies.set("data", base64_encode(JSON.stringify(coockieData)), {
          path: "/",
        });
        // console.log(JSON.stringify(rolePermission2))
        // console.log(JSON.stringify(response.data?.data?.rolePermission2));
        localStorage.setItem(
          "rolePermission",
          JSON.stringify(response.data?.data?.rolePermission)
        );


        localStorage.setItem(
          "rolePermission2",
          JSON.stringify(response.data?.data?.rolePermission2)
        );

        // localStorage.removeItem('rolePermission3');
        //localStorage.setItem('rolePermission3', JSON.stringify(response2.data?.data?.modules));

        if (values.selectedLang) {
          this.cookies.set("language", values.selectedLang, { path: "/" });

        }
        if (values.remember) {
          this.cookies.set("logindetails", base64Input, { path: "/" });
        }
        await message.success("Login Successful", 2);

        if (coockieData.isadmin === 1) {
          // this.context.isAdmin = false;
          this.cookies.set("isAdmin", 1);
        } else {
          // this.context.isAdmin = true;
          this.cookies.set("isAdmin", -1);
        }

        const path = coockieData.showLaunchingDashboard === 0 ? "/livetracking" : "/launchingDashboard";
        const globalCtrl = config.displayDomains?.[config.project] || [];
        const projectName = baseConfig.flavors['proawtltrack']?.project;


        if (coockieData.isadmin === 1 && response.data.data.verifyAdmin !== "1" && config.loginOtp && response.data.data.parentId === 101) {
          this.setState({ showUpdateInfoModal: true, pendingNavigatePath: path, loading: false });
        }
        else if (((coockieData.isadmin == 3 && response.data.data.distOtpPermission == 1) || (coockieData.issuperadmin == 1 && response.data.data.userId == 1)) && config.loginOtp) {
          this.handleverificationotp()
          this.setState({ showAlertModal: true, pendingNavigatePath: path, loading: false });
        }
        else {
          this.setState({ loading: false });
          this.props.navigate(path);
        }
        // this.props.navigate("/lounchingDashboard");
      } else {
        console.log("error");

        message.error(response.data.errors.loginerror);
        this.setState({ loading: false });
        //  message.error(response.data.data.errors.loginerror);
      }
    } catch (e) {
      message.error(response?.data?.message || "Something went wrong. Retry.");
      this.setState({ loading: false });
      //message.error(response.data.data.errors.loginer
      //var message = e.response?.data?.message || "Something went wrong. Retry.";
    }
  }
  onLangChange = (val) => {

    // Save to cookie
    this.cookies.set("language", val, { path: "/" });

    // Apply locale
    this.context.setLocale(val);

    // Update state
    this.setState({ selectedLang: val });

    // Only reset username/password fields, NOT selectedLang
    this.props.form[0].setFieldsValue({
      userEmail: "",
      password: "",
      selectedLang: val,   // ← keep selectedLang as the new value
    });
  };

  resetpass = () => {
    console.log("click");
    this.setState({ forgetpassmodal: true });
  };
  onFinishForgetPass = async (values) => {
    await this.setState({ forgetPassLoading: true });
    console.log(values);
    const resp = await this.forgetPassStore.forgetPass(values);

    // if (res.data.success === "success") {
    //   // Modal.success({
    //   //   content:this.context.translate( res.data.message),
    //   // });
    //  await message.success(res.data.message);
    //  await this.setState({forgetpassmodal:false})
    // } else {
    //   Modal.error({
    //     // content:res.data.errors[0].erroruser,
    //     title: this.context.translate("_ERROR_"),

    //     content:this.context.translate( res.data.errors[0].erroruser),
    //     // bodyStyle: { padding: "20px" ,background:"yellow"},
    //   });
    // }

    if (resp.data.success === "S") {
      message.success(resp.data.message);
      await this.setState({ forgetPassLoading: false });
      await this.setState({ forgetpassmodal: false });
    } else if (resp.data.success === "F0") {
      // resp.data.errors.map((value) => {

      message.error(this.context.translate(resp.data.errors[0].erroruser));
      await this.setState({ forgetPassLoading: false });
      // });
    }
  };
  // async onDelete(record) {
  //   console.log(record.simId, "record");
  //   const response = await this.simStore.deleteRecord({
  //     simId: record.simId,
  //   });

  // }
  handleAppleStates = () => {
    this.setState({
      openModalForQRCode: true,
      showQRCode: true,
      showGoogleQRCode: false,
      showAppGalleryQRCode: false,
    });
  };

  handleGoogleStates = () => {
    this.setState({
      openModalForQRCode: true,
      showGoogleQRCode: true,
      showQRCode: false,
      showAppGalleryQRCode: false,
    });
  };

  handleAppGalleryStates = () => {
    this.setState({
      openModalForQRCode: true,
      showGoogleQRCode: false,
      showQRCode: false,
      showAppGalleryQRCode: true,
    });
  };


  updateIcons = () => {
    const favicon = config.project
      ? `/logos/${config.project}-favicon.ico`
      : "/logos/trackeazy-favicon.ico";
    return {
      favicon: favicon,
      // favicon: `/logos/${config.project}-favicon.ico`,
      appleTouchIcon: drive7Icon,
    };
  }

  updateTitle = () => {
    return config.tabTitle ? config.tabTitle : "Trackeazy"
  }

  onsubmitotpdata = async (values) => {

    // await this.setState({ forgetPassLoading: true });
    const language = this.state.selectedLang

    const companyId = this.state.loginRes.companyId;
    const isUpdate = 1;

    await this.userstoresubmit.otpsubmit({ ...values, companyId, language, isUpdate });

    await this.setState({ showVerifyOtpModal: true }, () => {
      this.startOtpTimer();
    });

  }

  handleskipbutton = async () => {

    const companyId = this.state.loginRes.companyId;
    const isLogin = 1;

    // await this.setState({ forgetPassLoading: true });
    this.setState({ showUpdateInfoModal: false });
    this.props.navigate(this.state.pendingNavigatePath);

    await this.userstoresubmit.skipbutton({ companyId, isLogin });
  }

  handleResendOtp = async () => {
    const { otpFormData, loginRes, selectedLang } = this.state;
    const postData = {
      email: otpFormData.updateEmail,
      phoneNo: otpFormData.updatePhone,
      language: selectedLang || "english",
      companyId: loginRes.companyId,
    };
    console.log("resend otp postData", postData);
    await this.userstoresubmit.resendOtp(postData);
  }

  // handleotpvalidate = async (values) => {
  //   console.log("Abhishek")
  //   const companyId = this.state.loginRes.companyId;
  //   console.log("values", values);
  //   await this.userstoresubmit.validateotp({ ...values, companyId });
  //   this.setState({ showVerifyOtpModal: false });
  //   this.props.navigate(this.state.pendingNavigatePath);
  // }
  //  handleotpvalidate = async (values) => {
  //   console.log("Abhishek");

  //   const companyId = this.state.loginRes.companyId;

  //   try {
  //     const response = await this.userstoresubmit.validateotp({
  //       ...values,
  //       companyId,
  //     });


  //     console.log("OTP response:", response);
  //     console.log("DDDDDDDDDDD",response.success)

  //     if (response && response.success === "S") {
  //       // ✅ OTP correct
  //       this.setState({ showVerifyOtpModal: false });
  //       this.props.navigate(this.state.pendingNavigatePath);
  //     } else {
  //       // ❌ OTP incorrect → stay on same page
  //       console.log(response.message);

  //       this.setState({
  //         otpError: response.message || "Invalid OTP",
  //       });
  //     }

  //   } catch (error) {
  //     console.log("Error validating OTP:", error);

  //     this.setState({
  //       otpError: "Something went wrong. Please try again.",
  //     });
  //   }
  // };

  handleotpvalidate = async (values) => {
    try {
      const companyId = this.state.loginRes.companyId;

      const response = await this.userstoresubmit.validateotp({
        ...values,
        companyId,
      });

      console.log(response, "OTP validate response");

      // ✅ Check success flag from API
      const isSuccess = response?.success === 'S';

      this.setState({
        emailOtpVerified: isSuccess,
        phoneOtpVerified: isSuccess,
        otpValidationMessage: isSuccess
          ? { type: "success", text: "Verified successfully!" }
          : { type: "error", text: response?.message || "Verification failed. Please try again." },
      });

    } catch (err) {
      console.log(err, "OTP validate error");
      this.setState({
        emailOtpVerified: false,
        phoneOtpVerified: false,
        otpValidationMessage: {
          type: "error",
          text: err?.response?.data?.message || err?.message || "Verification failed. Please try again.",
        },
      });
    }
  };

  handleverificationotp = async () => {
    const language = this.state.selectedLang
    await this.userstoresubmit.sendverificationotp({ userId: this.state.loginRes.userId, phoneNo: this.state.loginRes.mobileno, language: this.state.selectedLang });
    // await this.setState({ showAlertModal: false, showVerifyOtpAdminModal: true }, () => {
    //   this.startOtpTimer();
    // });
  }

  verifymobileotp = async (values) => {
    const result = await this.userstoresubmit.verifymobileadminotp({ ...values, userId: this.state.loginRes.userId });
    if (result.data.success === "S") {
      await this.setState({ showVerifyOtpAdminModal: false });
      await this.props.navigate(this.state.pendingNavigatePath);
    } else {
      message.error(
        result?.data?.message ||
        result?.data?.error ||
        "Invalid OTP"
      );
    }
  }

  adminresendotp = async () => {
    console.log("IIIIIIITTTTTTTTTTTT");
    await this.userstoresubmit.adminresendoptlogin({ userId: this.state.loginRes.userId, phoneNo: this.state.loginRes.mobileno })
    this.startOtpTimer();
  }

  startOtpTimer = () => {
    // Clear existing interval if any
    if (this.state.otpTimerInterval) {
      clearInterval(this.state.otpTimerInterval);
    }

    this.setState({ otpTimer: 600, otpTimerActive: true });

    const interval = setInterval(() => {
      this.setState((prev) => {
        if (prev.otpTimer <= 1) {
          clearInterval(interval);
          return { otpTimer: 0, otpTimerActive: false, otpTimerInterval: null };
        }
        return { otpTimer: prev.otpTimer - 1 };
      });
    }, 1000);

    this.setState({ otpTimerInterval: interval });
  };

  // Format seconds to MM:SS
  formatTimer = (seconds) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  // Handle resend
  handleResendOtp = async () => {
    await this.sendOtpAgain(); // your resend API call
    this.startOtpTimer();      // restart timer
  };

  handleSave = async (values) => {
    console.log(values, "save");
    const userId = this.state.loginRes.userId;
    const companyId = this.state.loginRes.companyId;
    const resp = this.userstoresubmit.saveuserdetails({ userId, companyId })
    console.log(resp);
    await this.setState({ showVerifyOtpModal: false });
    await this.props.navigate(this.state.pendingNavigatePath);

  }
  componentWillUnmount() {
    if (this.state.otpTimerInterval) {
      clearInterval(this.state.otpTimerInterval);
    }
  }

  componentDidMount() {
    const savedLang = this.cookies.get("language") || "english";

    // Apply locale to context
    this.context.setLocale(savedLang);

    // Set state
    this.setState({ selectedLang: savedLang });

    // Set form field AFTER setting state to avoid reset overwriting it
    this.props.form[0].setFieldsValue({
      selectedLang: savedLang,
    });
  }

  render() {
    const { favicon, appleTouchIcon } = this.updateIcons();
    return (
      <>
        <Helmet>
          <title>{this.updateTitle()}</title>
          <link rel="icon" href={favicon} />
          <link rel="apple-touch-icon" href={appleTouchIcon} />
        </Helmet>
        <div
          className="theme-login-wrapper"
          style={{
            //height: "100%",
            //width: "60%",
            // position: "relative",
            // overflow: "hidden",
            // backgroundImage: config.useBgVideo
            //   ? null
            //   : `url(${require("../assets/images/" +
            //     (config.loginBgImage
            //       ? config.loginBgImage
            //       : "new_login_bg.png"))})`,
            backgroundImage: config.useBgVideo
              ? null
              : `url(${require("../assets/images/" +
                (config.loginBgImage
                  ? config.loginBgImage
                  : "new_login_bg.png"))})`,
            //backgroundSize: "cover",
            direction:
              this.context.locale.language === "arabic" ? "rtl" : "ltr",
          }}
        >
          {config.useBgVideo && (
            <video autoPlay muted loop>
              <source
                src={require("../assets/images/drive7/video-short.mp4")}
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          )}

          <div className={`login-container ${config.loginWindowAlign}Position`}>
            <div className="welcomeInfo">
              <p>
                {config.language == "spanish"
                  ? "Encantado de verte de nuevo"
                  : this.context.translate("_NICE_TO_SEE_YOU_AGAIN_")}
              </p>
              <h1>
                {config.language == "spanish"
                  ? "Bienvenido de nuevo"
                  : this.context.translate("_WELCOME_BACK_")}
              </h1>
            </div>
            <div className="login-form">
              <div className="login-logo">
                <Image
                  // src={require("../assets/images/" + config.loginlogo)}
                  src={`/logos/${config.project}-login.png`}
                  fallback={require(`../assets/images/trackeazy-logo.png`)}
                />
              </div>
              <div className="languageBlock">
              </div>
              <Form
                name="normal_login"
                //className="login-form"
                layout="vertical"
                initialValues={{
                  remember: true,
                  selectedLang: this.cookies.get("language") || "english",
                }}
                form={this.props.form[0]}
                onFinish={this.submitHandler}
              >
                <Form.Item name="selectedLang">
                  <Select
                    className="languageDropdown"
                    style={{ width: 120 }}
                    onChange={(val) => {
                      this.onLangChange(val);
                      // this.props.form[0].setFieldsValue({
                      //   selectedLang: val,
                      // });
                    }}
                  >
                    <Select.Option value="english">English</Select.Option>
                    <Select.Option value="arabic">العربية</Select.Option>
                    <Select.Option value="spanish">Español</Select.Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  name="userEmail"
                  label={this.context.translate(
                    "_FLEET_COMPANY_USERDETAIL_USERNAME_"
                  )}
                  className="formfield username"
                  rules={[
                    {
                      required: true,
                      message: this.context.translate(
                        "_FLEET_COMPANY_USERNAME_PROVIDE_"
                      ),
                    },
                  ]}
                >
                  <Input
                    size="large"
                    placeholder={this.context.translate("_USERNAME_")}
                  />
                </Form.Item>
                <Form.Item
                  className="formfield password"
                  label={this.context.translate(
                    "_FLEET_COMPANY_USERDETAIL_PASSWORD_"
                  )}
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: this.context.translate(
                        "_FLEET_COMPANY_PASSWORD_PROVIDE_"
                      ),
                    },
                  ]}
                >
                  <Input.Password
                    autoComplete="fail"
                    style={{ padding: "0 0" }}
                    type="password"
                    placeholder={this.context.translate(
                      "_FLEET_LOGIN_PASSWORDLBL_"
                    )}
                    size="large"
                    iconRender={(visible) =>
                      visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                    }
                  />
                </Form.Item>

                {/* <Form.Item> */}
                {/* <Row style={{ direction: this.context?.locale.direction }}> */}
                <div className="loginLinks">
                  <Form.Item
                    className="loginCheckbox"
                    name="remember"
                    valuePropName="checked"
                    noStyle
                  >
                    <Checkbox>
                      {this.context.translate("_FLEET_LOGIN_REMEMBER_")}
                    </Checkbox>
                  </Form.Item>
                  <Form.Item>
                    <div>
                      <a
                        className="forgotLink"
                        onClick={() => this.setState({ forgetpassmodal: true })}
                      >
                        {this.context.translate("_FLEET_LOGIN_FRWDBTN_")}?
                      </a>
                    </div>
                  </Form.Item>
                </div>
                {/* </Row> */}
                {/* </Form.Item> */}

                <Form.Item>
                  <Button
                    size="large"
                    type="primary"
                    htmlType="submit"
                    loading={this.state.loading}
                    className="loginBtn"
                    block
                  >
                    {this.context.translate("_FLEET_LOGIN_LOGINBTN_")}
                  </Button>
                </Form.Item>
              </Form>
              <div style={{ display: "flex", }}>
                <AddLoginFields
                  handleGoogleStates={this.handleGoogleStates}
                  handleAppleStates={this.handleAppleStates}
                  handleAppGalleryStates={this.handleAppGalleryStates}

                // openModalForQRCode={this.state.openModalForQRCode}
                // showGoogleQRCode={this.state.showGoogleQRCode}
                // showQRCode={this.state.showQRCode}
                />

              </div>

              <Modal
                open={this.state.openModalForQRCode}
                onCancel={() => this.setState({ openModalForQRCode: false })}
                footer={null}
                title="Scan QRCode to Download App!"
                width={350}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  {this.state.showGoogleQRCode && (
                    <div style={{ marginTop: 20, alignItems: "center" }}>
                      <QRCode value="https://play.google.com/store/apps/details?id=com.awtl.track" />
                    </div>
                  )}

                  {this.state.showQRCode && (
                    <div style={{ marginTop: 20, alignItems: "center" }}>
                      <QRCode value="https://apps.apple.com/us/app/awtltrack/id1507353643" />
                    </div>
                  )}

                  {this.state.showAppGalleryQRCode && (
                    <div style={{ marginTop: 20, alignItems: "center" }}>
                      <QRCode value="https://appgallery.cloud.huawei.com/ag/n/app/C102853095?locale=en_US" />
                    </div>
                  )}
                </div>
              </Modal>
            </div>
            <Modal
              title="Update Information"
              open={this.state.showUpdateInfoModal}
              onCancel={() => {
                this.setState({ showUpdateInfoModal: false });
              }}
              footer={null}
              maskClosable={false}
              centered
              width={480}

            >
              <Form
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                labelAlign="left"
                onFinish={async (vals) => {
                  this.setState({ otpFormData: vals });
                  await this.onsubmitotpdata(vals);
                  this.setState({ showUpdateInfoModal: false, showVerifyOtpModal: true });
                }}

              >
                <Form.Item
                  label="Email"
                  name="updateEmail"
                  style={{ marginBottom: "20px" }}
                  rules={[{ required: true, type: "email", message: "Please enter a valid email" }]}
                // placeholder={}
                >
                  <Input placeholder="Please Enter your email" />
                </Form.Item>

                <Form.Item
                  label="Phone No"
                  name="updatePhone"
                  style={{ marginBottom: "20px" }}
                  rules={[{ required: true, message: "Please enter phone number" }]}
                >
                  <Input placeholder="Please Enter your Phone number" />
                </Form.Item>

                <Form.Item wrapperCol={{ offset: 8, span: 16 }} style={{ textAlign: "right", marginBottom: 0 }}>
                  <Button type="primary" htmlType="submit" style={{ marginRight: 8 }}>SUBMIT</Button>
                  <Button
                    onClick={() => this.handleskipbutton()}
                    type="primary"
                    disabled={this.state.loginRes?.adminLoginCount > 5}
                  >
                    SKIP
                  </Button>
                </Form.Item>
              </Form>
            </Modal>
            {/* <Modal
                title="Verify OTP"
                open={this.state.showVerifyOtpModal}
                onCancel={() => {
                  clearInterval(this.state.otpTimerInterval);
                  this.setState({ showVerifyOtpModal: false, otpTimer: 600, otpTimerActive: false });
                  this.props.navigate(this.state.pendingNavigatePath);
                }}
                footer={null}
                maskClosable={false}
                centered
                width={480}
              >
                <Form
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  labelAlign="left"
                  onFinish={async (vals) => {
                    await this.handleotpvalidate(vals);
                  }}
                >
                  <Form.Item
                    label="Email OTP"
                    name="emailOtp"
                    style={{ marginBottom: "20px" }}
                    rules={[{ required: true, message: "Please enter email OTP" }]}
                  >
                    <Input placeholder="Enter Email OTP" />
                  </Form.Item>

                  <Form.Item
                    label="Phone No OTP"
                    name="phoneOtp"
                    style={{ marginBottom: "20px" }}
                    rules={[{ required: true, message: "Please enter phone OTP" }]}
                  >
                    <Input placeholder="Enter Phone OTP" />
                  </Form.Item>

               
                  <Form.Item wrapperCol={{ offset: 9, span: 16 }} style={{ marginBottom: 12 }}>
                    {this.state.otpTimerActive ? (
                      <span style={{ fontSize: 13, color: "#030301" }}>
                        OTP expires in: <strong>{this.formatTimer(this.state.otpTimer)}</strong>
                      </span>
                    ) : (
                      <span style={{ fontSize: 13, color: "#ff4d4f" }}>
                        OTP expired. Please resend.
                      </span>
                    )}
                  </Form.Item>

                  <Form.Item wrapperCol={{ offset: 8, span: 16 }} style={{ textAlign: "right", marginBottom: 0 }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ marginRight: 8 }}
                      disabled={!this.state.otpTimerActive} // ✅ disable VALIDATE after expiry
                    >
                      VALIDATE
                    </Button>
                    <Button
                      type="primary"
                      disabled={this.state.otpTimerActive} // ✅ disable RESEND while timer active
                      onClick={() => this.handleResendOtp()}
                    >
                      RESEND
                    </Button>
                  </Form.Item>
                </Form>
              </Modal> */}

            <Modal
              title="Verify OTP"
              open={this.state.showVerifyOtpModal}
              onCancel={() => {
                clearInterval(this.state.otpTimerInterval);
                this.setState({
                  showVerifyOtpModal: false,
                  otpTimer: 600,
                  otpTimerActive: false,
                  emailOtpVerified: false,
                  phoneOtpVerified: false,
                  otpValidationMessage: null,
                });
                // this.props.navigate(this.state.pendingNavigatePath);
              }}
              footer={null}
              maskClosable={false}
              centered
              width={480}
            >
              <Form
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                labelAlign="left"
                onFinish={async (vals) => {
                  await this.handleotpvalidate(vals);
                }}
              >
                {/* Email OTP */}
                <Form.Item
                  label="Email OTP"
                  name="emailOtp"
                  style={{ marginBottom: "20px" }}
                  rules={[{ required: true, message: "Please enter email OTP" }]}
                  // ✅ Green tick when email is verified
                  validateStatus={this.state.emailOtpVerified ? "success" : ""}
                  hasFeedback={this.state.emailOtpVerified}
                >
                  <Input
                    placeholder="Enter Email OTP"
                    disabled={this.state.emailOtpVerified} // lock input once verified
                  />
                </Form.Item>

                {/* Phone OTP */}
                <Form.Item
                  label="Phone No OTP"
                  name="phoneOtp"
                  style={{ marginBottom: "20px" }}
                  rules={[{ required: true, message: "Please enter phone OTP" }]}
                  // ✅ Green tick when phone is verified
                  validateStatus={this.state.phoneOtpVerified ? "success" : ""}
                  hasFeedback={this.state.phoneOtpVerified}
                >
                  <Input
                    placeholder="Enter Phone OTP"
                    disabled={this.state.phoneOtpVerified} // lock input once verified
                  />
                </Form.Item>

                {/* ✅ Success / Error message from API */}
                {this.state.otpValidationMessage && (
                  <Form.Item wrapperCol={{ offset: 8, span: 16 }} style={{ marginBottom: 12 }}>
                    <span
                      style={{
                        fontSize: 13,
                        color: this.state.otpValidationMessage.type === "success" ? "#52c41a" : "#ff4d4f",
                        fontWeight: 500,
                      }}
                    >
                      {this.state.otpValidationMessage.type === "success" ? "✅ " : "❌ "}
                      {this.state.otpValidationMessage.text}
                    </span>
                  </Form.Item>
                )}

                {/* Timer */}
                <Form.Item wrapperCol={{ offset: 9, span: 16 }} style={{ marginBottom: 12 }}>
                  {this.state.otpTimerActive ? (
                    <span style={{ fontSize: 13, color: "#030301" }}>
                      OTP expires in: <strong>{this.formatTimer(this.state.otpTimer)}</strong>
                    </span>
                  ) : (
                    <span style={{ fontSize: 13, color: "#ff4d4f" }}>
                      OTP expired. Please resend.
                    </span>
                  )}
                </Form.Item>

                {/* Buttons */}
                <Form.Item wrapperCol={{ offset: 8, span: 16 }} style={{ textAlign: "right", marginBottom: 0 }}>
                  {/* VALIDATE — hidden once both are verified */}
                  {!(this.state.emailOtpVerified && this.state.phoneOtpVerified) && (
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ marginRight: 8 }}
                      disabled={!this.state.otpTimerActive}
                    >
                      VALIDATE
                    </Button>
                  )}

                  {/* RESEND */}
                  <Button
                    type="primary"
                    disabled={this.state.otpTimerActive}
                    onClick={() => {
                      this.setState({ emailOtpVerified: false, phoneOtpVerified: false, otpValidationMessage: null });
                      this.handleResendOtp();
                    }}
                    style={{ marginRight: 8 }}
                  >
                    RESEND
                  </Button>

                  {/* ✅ SAVE — enabled only when both verified */}
                  <Button
                    type="primary"
                    disabled={!(this.state.emailOtpVerified && this.state.phoneOtpVerified)}
                    onClick={() => {
                      clearInterval(this.state.otpTimerInterval);
                      this.setState({ showVerifyOtpModal: false, otpTimer: 600, otpTimerActive: false });
                      this.handleSave(); // 👈 replace with your actual save handler
                    }}
                  >
                    SAVE
                  </Button>
                </Form.Item>
              </Form>
            </Modal>

            <Modal
              title="Alert"
              open={this.state.showAlertModal}
              onCancel={() => {
                this.setState({ showAlertModal: false });
              }}
              footer={null}
              maskClosable={false}
              centered
              width={480}
              styles={{
                header: {
                  background: "#3a3a3a",
                  borderRadius: "4px 4px 0 0",
                  padding: "8px 14px",
                },
                content: { padding: 0, borderRadius: 4, overflow: "hidden" },
                body: { padding: "14px 16px 12px 16px" },
              }}
              closeIcon={
                <span style={{ color: "#fff", fontSize: 14 }}>✕</span>
              }
            >
              <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 14 }}>
                <CheckCircleOutlined style={{ color: "#52c41a", fontSize: 16, flexShrink: 0 }} />
                <p style={{ fontSize: 13, margin: 0, lineHeight: "1.5" }}>
                  The verification code has been sent successfully.
                </p>
              </div>

              <div style={{ textAlign: "center" }}>
                <Button
                  type="primary"
                  style={{ padding: "6px 24px", height: "32px", fontSize: "13px" }}
                  onClick={() => {
                    this.setState(
                      {
                        showAlertModal: false,
                        showVerifyOtpAdminModal: true,
                      },
                      () => {
                        this.startOtpTimer();
                      }
                    );
                  }}
                >
                  OK
                </Button>
              </div>
            </Modal>

            {/* <Modal
                title="Alert"
                open={this.state.showVerifyOtpAdminModalconfirmation}
                onCancel={() => {
                  this.setState({ showVerifyOtpAdminModalconfirmation: false });
                }}
                footer={null}
                maskClosable={false}
                centered
                width={480}
                styles={{
                  header: {
                    background: "#3a3a3a",
                    borderRadius: "4px 4px 0 0",
                    padding: "8px 14px",
                  },
                  content: { padding: 0, borderRadius: 4, overflow: "hidden" },
                  body: { padding: "14px 16px 12px 16px" },
                }}
                closeIcon={
                  <span style={{ color: "#fff", fontSize: 14 }}>✕</span>
                }
              >
                <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 14 }}>
                  <CheckCircleOutlined style={{ color: "#52c41a", fontSize: 16, flexShrink: 0 }} />
                  <p style={{ fontSize: 13, margin: 0, lineHeight: "1.5" }}>
                    The verification code has been sent successfully.
                  </p>
                </div>

                <div style={{ textAlign: "center" }}>
                 <Button
                type="primary"
                style={{ padding: "6px 24px", height: "32px", fontSize: "13px" }}
                onClick={() => {
                  this.handleverificationotp()  
                }}
              >
                OK
              </Button>
                </div>
              </Modal> */}

            <Modal
              title="Verify OTP"
              open={
                this.state.showVerifyOtpAdminModal}
              onCancel={() => {
                clearInterval(this.state.otpTimerInterval);
                this.setState({ showVerifyOtpAdminModal: false, otpTimer: 600, otpTimerActive: false });
              }}
              footer={null}
              maskClosable={false}
              centered
              width={480}
            >
              <Form
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                labelAlign="left"
                onFinish={async (values) => {
                  await this.verifymobileotp(values);
                }}
              >
                <Form.Item
                  label="Enter OTP"
                  name="phoneOtp"
                  style={{ marginBottom: "20px" }}
                  rules={[{ required: true, message: "Please enter OTP" }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item wrapperCol={{ offset: 9, span: 16 }} style={{ marginBottom: 12 }}>
                  {this.state.otpTimerActive ? (
                    <span style={{ fontSize: 13, color: "#030301" }}>
                      OTP expires in: <strong>{this.formatTimer(this.state.otpTimer)}</strong>
                    </span>
                  ) : (
                    <span style={{ fontSize: 13, color: "#ff4d4f" }}>
                      OTP expired. Please resend.
                    </span>
                  )}
                </Form.Item>

                <Form.Item wrapperCol={{ offset: 8, span: 16 }} style={{ textAlign: "right", marginBottom: 0 }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ marginRight: 8 }}
                    disabled={!this.state.otpTimerActive}
                  >
                    VALIDATE
                  </Button>
                  <Button
                    type="primary"
                    disabled={this.state.otpTimerActive}
                    onClick={() => { this.adminresendotp() }}
                  >
                    RESEND
                  </Button>
                </Form.Item>
              </Form>
            </Modal>
            {this.state.forgetpassmodal && (
              <Modal
                title={this.context.translate("_FLEET_LOGIN_FRWDBTN_")}
                open={this.state.forgetpassmodal}
                onCancel={() => this.setState({ forgetpassmodal: false })}
                footer={null}
                maskClosable={false}
                centered
                style={{ padding: "20px", maxWidth: "440px" }}
              >
                <div>
                  <Spin spinning={this.state.forgetPassLoading} fullscreen>
                    <Form
                      name="basic"
                      ref={this.forgetFormRef}
                      onFinish={this.onFinishForgetPass}
                    >
                      <Form.Item
                        name="useremail"
                        rules={[
                          {
                            required: true,
                            type: "email",
                            message: this.context.translate("_ENTER_EMAILID_"),
                          },
                        ]}
                      >
                        <Input
                          className="customInput"
                          placeholder={this.context.translate(
                            "_ENTER_EMAILID_"
                          )}
                        />
                      </Form.Item>
                      <br />
                      <Form.Item>
                        <div className="forgetPassBtns">
                          <Button
                            className="commonBtns blueBtn"
                            htmlType="submit"
                          >
                            {this.context.translate(
                              "_FLEET_DASHBORD_VEHICLE_COMMAND_SENDBTN_"
                            )}
                          </Button>
                          <Button
                            className="commonBtns grayBtn"
                            onClick={() => {
                              this.forgetFormRef.current?.resetFields();
                              this.setState({ forgetpassmodal: false });
                            }}
                          >
                            {this.context.translate(
                              "_FLEET_DASHBORD_SHOWPOI_CANCELBTN_"
                            )}
                          </Button>
                        </div>
                      </Form.Item>
                    </Form>
                  </Spin>
                </div>
              </Modal>
            )}
          </div>

          <AWTLHelpSection />

        </div>

      </>
    );
  }
}

Login.contextType = StoreContext;
export default observer(withRouter(Login));
